import { Scale, ProductId } from 'root/model/map/MapEnums';

export const parseMapScale = (typeString: string) => {
    return Scale[typeString as keyof typeof Scale];
};

export const parseProductId = (typeString: string) => {
    return ProductId[typeString as keyof typeof ProductId];
};
